import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'fr8bot-web-menu-button',
  templateUrl: './web-menu-button.html',
  styleUrl: './web-menu-button.scss',
  imports: [NgClass, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebMenuButton {
  isSelected = input(false);
  link = input('');
}
